import { render, staticRenderFns } from "./verhuisbedrijf.vue?vue&type=template&id=c9121062"
import script from "./verhuisbedrijf.vue?vue&type=script&lang=js"
export * from "./verhuisbedrijf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports